import { Grid } from '@mui/material'

import TimelineComponent from '~/components/common/TimelineComponent'
import type { TimelineEntryType } from '~/constants/timelineConstants'

import ClientAndPatientMarketplacePanel from '../../details/new-client-and-patient/ClientAndPatientMarketplacePanel'

interface RecordsComponentProps {
  applyFilters?: TimelineEntryType[]
  clientId: string
  patientId: string
}

const RecordsComponent = ({
  clientId,
  patientId,
  applyFilters,
}: RecordsComponentProps) => (
  <Grid container item direction="column" wrap="nowrap">
    <ClientAndPatientMarketplacePanel
      clientId={clientId}
      patientId={patientId}
    />
    <TimelineComponent
      applyFilters={applyFilters}
      clientId={clientId}
      patientId={patientId}
    />
  </Grid>
)

export default RecordsComponent
